import { AppliedCoupon, AssignedCoupon } from '@app/types/cart/Coupon';
import { Box, Text } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import React, { FC } from 'react';
import styles from './Coupon.module.scss';
import { CouponList } from './CouponList/CouponList';
import { LOGIN_LINK, SIGNUP_LINK } from './constants';
import { couponMessages } from './messages';
import { SignUp } from './SignUp/SignUp';

interface MemberOffersProps {
  isGetUserQueryServerError: boolean;
  appliedCoupon?: AppliedCoupon;
  assignedCoupons?: AssignedCoupon[];
  onCouponAction: (coupon: AssignedCoupon, isApply: boolean) => void;
  isLoading: boolean;
}

export const MemberOffers: FC<MemberOffersProps> = ({
  isGetUserQueryServerError,
  appliedCoupon,
  assignedCoupons,
  onCouponAction,
  isLoading,
}) => {
  const intl = useIntl();
  const [{ locale, isLoggedIn }] = useUserInfo<UserInfo>();

  return (
    <Box className={styles.memberOffers}>
      <Box marginBottom="m">
        <Text type="display5">
          {intl.formatMessage(couponMessages.couponMemberOffers)}
        </Text>
      </Box>
      {isLoggedIn ? (
        <CouponList
          locale={locale}
          isGetUserQueryServerError={isGetUserQueryServerError}
          appliedCoupon={appliedCoupon}
          assignedCoupons={assignedCoupons}
          onCouponAction={onCouponAction}
          isLoading={isLoading}
        />
      ) : (
        <SignUp loginLink={LOGIN_LINK} signUpLink={SIGNUP_LINK} />
      )}
    </Box>
  );
};
